import type { ReactNode } from 'react';

import { CompositeControlSlot, CompositeGrid, CompositeValueSlot } from '../ScenarioGrid.style';

type CompositeValueProps = {
    control?: ReactNode;
    children: ReactNode;
};

export const CompositeValue = ({ control, children }: CompositeValueProps) => (
    <CompositeGrid>
        {control && <CompositeControlSlot>{control}</CompositeControlSlot>}
        <CompositeValueSlot>{children}</CompositeValueSlot>
    </CompositeGrid>
);
